import React, { useMemo, useState } from "react";
import {
  PieChart,
  Pie,
  Sector,
  ResponsiveContainer,
  Tooltip as ReTooltip,
  Cell,
} from "recharts";

type DonutItem = {
  name: string;
  value: number;
  color: string;
};

interface DashBoardDonutChartProps {
  data?: DonutItem[];
}

const defaultData: DonutItem[] = [
  { name: "상담사 응답 완료", value: 0, color: "#2D91FF" },
  { name: "상담사 미응답", value: 0, color: "#F97575" },
];

// hover 시 살짝 바깥 링 주는 activeShape
const renderActiveShape = (props: any) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={(outerRadius ?? 0) + 4}
        outerRadius={(outerRadius ?? 0) + 8}
        fill={fill}
      />
    </g>
  );
};

export default function DashBoardDonutChart({ data = defaultData }: DashBoardDonutChartProps) {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const total = useMemo(
    () => data.reduce((sum, d) => sum + d.value, 0),
    [data]
  );

  return (
    <div className="flex-c flex-wrap gap-40 m-auto">
      {/* 왼쪽: 도넛 */}
      <div className="donutchart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              cx="50%"
              cy="50%"
              innerRadius="70%"
              outerRadius="88%"
              startAngle={90}
              endAngle={-270}
              paddingAngle={0}
              onMouseEnter={(_, index) => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(0)}
            >
              {data.map((entry, idx) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>

            {/* 툴팁 안 쓸거면 null */}
            <ReTooltip content={() => null} />
          </PieChart>
        </ResponsiveContainer>

        {/* 가운데 텍스트 (이미지처럼) */}
        <div className="donutchart-center">
          <div className="num">
            {total}건
          </div>
          <div className="tit">
            총 상담
          </div>
        </div>
      </div>

      {/* 오른쪽: 범례 */}
      <div className="donutchart-data">
        {data.map((item) => (
          <div
            key={item.name}
            className="donutchart-data-item"          
          >
            {/* 색상 점 */}
            <span className="donutchart-data-item-circle"
              style={{
                width: 14,
                height: 14,
                borderRadius: 999,
                backgroundColor: item.color,
              }}
            />

            {/* 라벨 + 점선(이미지 느낌) */}
            <div className="donutchart-data-item-label">{item.name}</div>

            {/* 값 */}
            <div className="donutchart-data-item-value">
              {item.value}건
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
